/**
 * Los límites de la interfaz. UN SOLO SITIO.
 *
 * Cuántas filas se piden, cuántas se enseñan antes de "ver todas", cuántos
 * nombres caben en una alerta. Son decisiones de producto que cambian juntas y
 * que alguien tiene que poder revisar de un vistazo: repartidas por los
 * componentes, cada pantalla acaba con un número distinto puesto a ojo.
 *
 * Los límites del SERVIDOR no están aquí: los pone el backend y los valida él.
 * Estos son los de esta interfaz.
 */

/** Filas que se piden al buscar en el padrón. */
export const PARTICIPANTS_PAGE_SIZE = 100;

/**
 * Lotes que enseña el Resumen antes de "ver todos". Vienen todos --la lista
 * del mes se recorre entera, ver `lib/pages.ts`--; esto es solo cuántos se
 * enseñan de entrada.
 */
export const RECENT_BATCHES_PREVIEW = 5;

/** Mecánicas que enseña la memoria antes de "ver todas". */
export const MECHANICS_PREVIEW = 4;

/**
 * Personas que nombra una alerta antes de rematar con "y N más".
 *
 * `get_period_coverage` pide explícitamente enseñar QUIÉN se quedó fuera y no
 * solo cuántos; tres nombres caben en una línea y ya dicen de quién se habla.
 */
export const ALERT_NAMES_PREVIEW = 3;

/** Meses que ofrece el selector del panel, contando el actual. */
export const PERIOD_CHOICES = 12;

/**
 * La ventana de chat de Work: ancho, alto y el margen que la separa del borde.
 *
 * El alto es el de partida; si la ventana del navegador no da para tanto, se
 * queda con lo que haya menos el margen. El armazón reserva este ancho cuando
 * está abierta --por eso el número vive aquí y no dentro del JSX-- para que la
 * ventana no tape la paginación de una tabla ni el pie de una pantalla.
 */
export const CHAT_BUBBLE_WIDTH = 380;
export const CHAT_BUBBLE_HEIGHT = 520;
export const CHAT_BUBBLE_MARGIN = 16;
/** El botón redondo cuando está cerrada. El armazón le reserva el pie. */
export const CHAT_BUBBLE_BUTTON = 48;

/**
 * Páginas que se piden, como mucho, al traer ENTERA una lista corta (los lotes
 * del mes, las mecánicas). Con el tope del backend, son cientos de filas: si
 * una lista de estas pasa de ahí, ya no es corta y merece otra pantalla.
 */
export const MAX_LIST_PAGES = 10;

/**
 * El largo máximo de un texto en un evento de telemetría: un mensaje, una
 * búsqueda, un título, un motivo. Lo que pase se corta con "…". No es por
 * privacidad --el texto se manda (#5)--, es para que un pegado de un Excel
 * entero no convierta un evento en megas.
 */
export const TELEMETRY_TEXT_MAX = 2000;
